import {
  UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_SUCCESS,
  LOAD_UPLOAD_INFORMATION_PAGE, UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_ERROR,
} from 'constants/ActionTypes';

export const loadUploadInformationPage = () => ({ type: LOAD_UPLOAD_INFORMATION_PAGE });

export const saveUploadInformationError = () => ({ type: UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_ERROR });

export const saveUploadInformationSuccess = (message) => ({ type: UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_SUCCESS, message });
